import Swiper, { EffectFade, Autoplay } from 'swiper';
import '../../../../node_modules/swiper/modules/effect-fade/effect-fade.scss';
import { playPauseVideo } from '../helpers/video';

Swiper.use([EffectFade, Autoplay]);

export const tabContentSliders = () => {
    const contentSectionModues = document.querySelectorAll('.m__tab-content');
    const mediaSliders = document.querySelectorAll('.js__tab-content-media-swiper');

	if ( contentSectionModues ) {
		contentSectionModues.forEach((sliderModule) => {
            const slider = sliderModule.querySelector('.m__tab-content__swiper');
			const sliderSlides = slider.querySelectorAll('.m__tab-content__section-slide');
			const slideVideos = slider.querySelectorAll('.js__tab-content-swiper-video');
			
			// Trigger the first video on page load
			if (slideVideos.length > 0) {
				for (var source in slideVideos[0].children) {
					var videoSource = slideVideos[0].children[source];
					if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
						videoSource.src = videoSource.dataset.src;
					}
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

			if (sliderSlides.length > 1) {
				// Initialise the slider
				const tabSwiper = new Swiper(slider, {
					slidesPerView: 1,
					loop: false,
					autoplay: false,
					keyboard: false,
					allowTouchMove: false,
				});

                // Updates when a slide changes
                tabSwiper.on('slideChange', function () {
                    // Stop all videos from playing
                    slideVideos.forEach((slideVideo) => {
                        slideVideo.pause();
                        slideVideo.currentTime = 0;
                        slideVideo.load();
                    })

                    // Check for any videos on the slide and make sure they're lazy-loaded
                    let slideVideo = tabSwiper.slides[tabSwiper.activeIndex].querySelector("video");

                    if (slideVideo) {
                        if (!slideVideo.currentTime > 0) { // Only reload video if it isn't already playing
                            for (var source in slideVideo.children) {
                                var videoSource = slideVideo.children[source];
                                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                    videoSource.src = videoSource.dataset.src;
                                }
                            }

                            slideVideo.load();
                            slideVideoTimeout = setTimeout(() => {
                                slideVideo.play();
                            }, 1000);
                        }
                    }
                });

                const tabs = sliderModule.querySelectorAll('.js__tab-content-trigger');

                if ( tabs ) {
                    tabs.forEach(tab => {
                        tab.addEventListener('click', (event) => {
                            event.preventDefault();
                            
                            if ( !tab.classList.contains('active') ) {
                                const tabId = tab.getAttribute('data-tab-id');

                                // Remove active class from all tabs
                                tabs.forEach(t => {
                                    t.classList.remove('active');
                                });
    
                                // Add active class to clicked tab
                                tab.classList.add('active');

                                // Slide to the tab
                                tabSwiper.slideTo(tabId);
                            }
                        });
                    });
                }
			}
		});
	}

    if ( mediaSliders ) {
		mediaSliders.forEach((slider) => {
            const sliderSlides = slider.querySelectorAll('.m__tab-content__highlight-slide');

            // Check if the first slide contains a video and if so play the video
            const initSlide = sliderSlides[0];
            const initSlideVideo = initSlide.querySelector('.js__tab-content-swiper-video'); 
    
            if ( initSlideVideo ) {
                initSlideVideo.play();
            }
    
            // Loop through each slide and initialise the playPuase functionality
            sliderSlides.forEach(slide => {
                const video = slide.querySelector('.js__tab-content-swiper-video');
                const videoControls = slide.querySelector('.js-video-controls');
        
                if ( video && videoControls ) {
                    playPauseVideo(video, videoControls);
                }
            });

			if (sliderSlides.length > 1) {
				// Initialise the slider
				const tabMediaSwiper = new Swiper(slider, {
                    centeredSlides: true,
                    slidesPerView: 1,
                    effect: "fade",
                    speed: 1500,
                    fadeEffect: {
                        crossFade: true
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
				});

                // Updates when a slide changes
                tabMediaSwiper.on('slideChange', function () {
                    // If the previous slide contains a video then pause the video
						const prevSlideVideo = tabMediaSwiper.slides[tabMediaSwiper.previousIndex].querySelector('.js__tab-content-swiper-video');

						if ( prevSlideVideo ) {
							prevSlideVideo.pause();
						}
		
						// Check if the current slide contains a video
						const currentSlide = tabMediaSwiper.slides[tabMediaSwiper.activeIndex];
						const currentSlideVideo = currentSlide.querySelector('.js__tab-content-swiper-video');
						const currentSlideVideoControls = currentSlide.querySelector('.js-video-controls');
		
						if ( currentSlideVideo && currentSlideVideoControls ) {
							// If the play icon is hidden this means that the video hasn't been paused before changing slides so play the video
							const playIcon = currentSlideVideoControls.querySelector('.e__video-controls-image--play');
		
							if ( playIcon && playIcon.classList.contains('hidden') ) {
								currentSlideVideo.play();
							}
						}
                });

                let sliderNextArrow = slider.closest('.m__tab-content__section-slide').querySelector('.js__tab-media__swiper-next');
                let sliderPrevArrow = slider.closest('.m__tab-content__section-slide').querySelector('.js__tab-media__swiper-prev');
                
                // Move to the previous slide if 'prev' arrow clicked
                if (sliderPrevArrow) {
                    sliderPrevArrow.addEventListener('click', (event) => {
                        let prevSlide = tabMediaSwiper.activeIndex - 1;
                        if (prevSlide < 0) {
                            prevSlide = tabMediaSwiper.slides.length; // Set to the last slide
                        }
                        tabMediaSwiper.slideTo(prevSlide);
                    })
                }

                // Move to the next slide if 'next' arrow clicked
                if (sliderNextArrow) {
                    sliderNextArrow.addEventListener('click', (event) => {
                        let nextSlide = tabMediaSwiper.activeIndex + 1;
                        if (nextSlide >= tabMediaSwiper.slides.length) {
                            nextSlide = 0; // Return to start!
                        }
                        tabMediaSwiper.slideTo(nextSlide);
                    })
                } 
			}
		});
	}
};